import * as React from 'react';
import { connect } from 'react-redux';
import { showTooltip, hideTooltip } from 'actions/tooltipActions';
import Card from './Card';
import styles from './Tooltip.css';
import Portal from 'components/Portal/Portal';
const node = null;
// TODO: Get rid of inheritance
export class Tooltip extends Portal({ node, nodeClassName: styles['tooltip-portal'] }) {
    constructor(props) {
        super(props);
        this.clearTimeout = (timerId) => {
            if (timerId)
                clearTimeout(timerId);
        };
        this.mouseOverTooltip = false;
        this.handleMouseEnterCard = this.handleMouseEnterCard.bind(this);
        this.handleMouseLeaveCard = this.handleMouseLeaveCard.bind(this);
        if (props.auto) {
            this.handleMouseEnter = this.handleMouseEnter.bind(this);
            this.handleMouseLeave = this.handleMouseLeave.bind(this);
        }
    }
    componentDidMount() {
        const { anchor } = this.props;
        this.anchorEl = typeof anchor === 'string' ? document.querySelector(anchor) : anchor;
        super.componentDidMount();
        if (!this.props.auto)
            return;
        if (this.anchorEl) {
            this.anchorEl.addEventListener('mouseenter', this.handleMouseEnter);
            this.anchorEl.addEventListener('mouseleave', this.handleMouseLeave);
        }
    }
    componentWillUnmount() {
        this.hoverInTimer && clearTimeout(this.hoverInTimer);
        if (this.anchorEl) {
            this.anchorEl.removeEventListener('mouseenter', this.handleMouseEnter);
            this.anchorEl.removeEventListener('mouseleave', this.handleMouseLeave);
        }
        super.componentWillUnmount();
    }
    visible(props) {
        return props.auto ? this.uid === props.visibleId : props.active;
    }
    shouldPortalUpdate() {
        return Boolean(this.anchorEl);
    }
    handleMouseEnter() {
        this.clearTimeout(this.hoverOutTimer);
        if (!this.isVisible) {
            this.hoverInTimer = setTimeout(this.show, this.props.hoverInTimeout);
        }
    }
    handleMouseLeave() {
        this.clearTimeout(this.hoverInTimer);
        if (this.isVisible && !this.mouseOverTooltip && !this.props.dismissible) {
            this.hoverOutTimer = setTimeout(this.hide, this.props.hoverOutTimeout);
        }
    }
    handleMouseEnterCard() {
        this.clearTimeout(this.hoverOutTimer);
        this.mouseOverTooltip = true;
    }
    handleMouseLeaveCard() {
        this.mouseOverTooltip = false;
        if (!this.props.dismissible) {
            this.hoverOutTimer = setTimeout(this.hide, this.props.hoverOutTimeout);
        }
    }
    renderChildren(props, active = false) {
        return (<Card {...props} anchor={this.anchorEl} active={active} onDismiss={this.hide} onMouseEnter={this.handleMouseEnterCard} onMouseLeave={this.handleMouseLeaveCard}/>);
    }
}
Tooltip.defaultProps = {
    active: false,
    auto: true,
    dismissible: false,
    hoverInTimeout: 300,
    hoverOutTimeout: 300
};
const mapStateToProps = ({ tooltip }) => ({ visibleId: tooltip.id });
const mapDispatchToProps = { showComponent: showTooltip, hideComponent: hideTooltip };
export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true
})(Tooltip);
